import { motion } from 'framer-motion';
import { Link, useNavigate } from 'react-router-dom';
import SearchInput from '../components/SearchInput';
import { galleryItems } from './OurWork';

const NotFound = () => {
  const navigate = useNavigate();

  const handleSearch = (query: string) => {
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query.trim())}`);
    }
  };
  return (
    <div className="min-h-screen bg-dark-gray">
      <div className="max-w-4xl mx-auto px-4 py-24 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-gray-900/50 backdrop-blur-sm p-12 rounded-xl border border-gray-800 shadow-2xl"
        >
          <div className="text-9xl font-bold text-burnt-orange mb-4">404</div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Oops! Page Not Found
          </h1>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            The page you're looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link 
              to="/" 
              className="bg-burnt-orange hover:bg-burnt-orange/90 text-white font-semibold py-3 px-8 rounded-md transition-colors inline-flex items-center justify-center"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              Back to Home
            </Link>
            
            <Link 
              to="/contact" 
              className="bg-transparent hover:bg-white/10 text-white font-semibold py-3 px-8 border-2 border-white rounded-md transition-colors inline-flex items-center justify-center"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Contact Us
            </Link>
          </div>
          
          <div className="mt-12 px-4">
            <p className="text-gray-500 mb-4">Or try searching for what you're looking for:</p>
            <div className="max-w-md mx-auto">
              <SearchInput
                placeholder="Search our site..."
                onSearch={handleSearch}
                showSuggestions={true}
                galleryData={galleryItems}
              />
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
